import { WithAppBarAndActionButton } from './with-appbar-and-action-button'
import { SearchableList } from '$common/searchable-list'
import {
  SearchableListPageOuterProps,
  SearchableListPageInnerProps,
} from './searchable-list-page.types'
import { nothing } from '$func/utils'
import { useCallback, useState } from 'react'
import { VirtualizedListOnScroll } from '$common/virtualized-list'
import { useLastCallback } from '$hooks/use-last-callback'

export function withSearchableListPage<Item, FetchParams, SearchParams>({
  appBarTitle,
  ListItem,
  SkeletonItem,
  EmptyStateComponent,
  itemSize = 57,
  fetchHook,
  searchHook,
  actionButtonText,
  actionButtonIcon,
  onActionButtonClick = nothing,
  subHeaderText,
  overscanCount = 3,
  onBack,
  FAB,
}: SearchableListPageOuterProps<Item, FetchParams, SearchParams>) {
  function SearchableListPage({
    hideActionButton,
    getSubHeaderText,
    fetchHookParams,
    getSearchHookParams,
  }: SearchableListPageInnerProps<Item, FetchParams, SearchParams>) {
    const { items, loading } = fetchHook(fetchHookParams)
    const [isFABVisible, setIsFABVisible] = useState(true)
    const handleScroll: VirtualizedListOnScroll = useLastCallback(
      ({ scrollDirection, scrollOffset }) => {
        //  ignore the first onscroll trigger (on component mount it triggers once without user interaction)
        if (!scrollOffset) return

        setIsFABVisible(scrollDirection === 'backward')
      },
    )

    return (
      <WithAppBarAndActionButton
        appBarTitle={appBarTitle}
        loading={loading}
        actionButtonText={actionButtonText}
        actionButtonIcon={actionButtonIcon}
        hideActionButton={hideActionButton}
        onActionButtonClick={onActionButtonClick}
        subHeaderText={
          getSubHeaderText
            ? getSubHeaderText(items?.length || 0)
            : subHeaderText
        }
        onBack={onBack}
        FAB={FAB}
        isFABVisible={isFABVisible}
      >
        {(listHeight: number, searchQuery: string) => (
          <SearchableList
            items={items}
            height={listHeight}
            ListItem={ListItem}
            SkeletonItem={SkeletonItem}
            EmptyStateComponent={EmptyStateComponent}
            itemSize={itemSize}
            searchQuery={searchQuery}
            searchHook={searchHook}
            searchHookParams={getSearchHookParams(searchQuery, items)}
            overscanCount={overscanCount}
            loading={loading}
            onScroll={handleScroll}
          />
        )}
      </WithAppBarAndActionButton>
    )
  }

  SearchableListPage.defaultProps = {
    hideActionButton: false,
    getSubHeaderText: null,
  }

  return SearchableListPage
}
